import React from 'react';
const testimonials = [{
  name: 'Valentina R.',
  location: 'Buenos Aires, Argentina 🇦🇷',
  quote: 'Literalmente me salvó la vida. Daba 15 clases por semana y no me daba la cabeza para planificar. Ahora abro el tomo, leo 5 minutos y tengo una clase hermosa armada.',
  initials: 'VR'
}, {
  name: 'Sofía M.',
  location: 'CDMX, México 🇲🇽',
  quote: 'Lo que más me gustó son los temas filosóficos. Siempre me costaba integrarlos sin sonar aburrida. Ahora mis alumnas me dicen que las clases tienen mucha más profundidad.',
  initials: 'SM'
}, {
  name: 'Camila G.',
  location: 'Bogotá, Colombia 🇨🇴',
  quote: 'El módulo de Yoga Terapéutico vale oro. Me sentía muy insegura cuando venían alumnas con dolor lumbar, ahora tengo protocolos claros para cuidarlas.',
  initials: 'CG'
}, {
  name: 'Martina L.',
  location: 'Santiago, Chile 🇨🇱',
  quote: 'Por $19 USD es un regalo. Solo el tracker anual y los captions de Instagram ya me ahorraron horas de trabajo. Muy recomendado para profes que recién empiezan.',
  initials: 'ML'
}, {
  name: 'Lucía P.',
  location: 'Montevideo, Uruguay 🇺🇾',
  quote: 'Las secuencias son súper fluidas y lógicas. Mis alumnas notaron el cambio enseguida, las clases se sienten mucho más profesionales y armadas.',
  initials: 'LP'
}, {
  name: 'Andrea C.',
  location: 'Lima, Perú 🇵🇪',
  quote: 'Me encanta que esté pensado para LATAM. El bono sobre el negocio del yoga me abrió la cabeza sobre cómo cobrar y valorar mi trabajo. ¡Gracias!',
  initials: 'AC'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-170">
      <div className="max-w-6xl mx-auto" data-id="element-171">
        <div className="text-center mb-12 sm:mb-16" data-id="element-172">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-173">
            Lo que dicen las profesoras de LATAM.
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-174">
            <span className="text-[#E0A52E] text-lg" data-id="element-175">⭐⭐⭐⭐⭐</span>
            <span className="text-text-sec font-medium" data-id="element-176">
              4.9/5 · +1.200 Profesoras
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-177">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-main rounded-2xl p-6 border border-border-light shadow-sm flex flex-col" data-id="element-178">
              <div className="flex items-center gap-2 mb-4" data-id="element-179">
                <span className="text-[#E0A52E] text-sm" data-id="element-180">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="text-text-main text-base leading-relaxed mb-6 flex-grow italic" data-id="element-181">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-182">
                <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-183">
                  {t.initials}
                </div>
                <div data-id="element-184">
                  <p className="text-text-main font-bold text-sm" data-id="element-185">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-186">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}